import React from 'react'
import Select from 'react-select'
import {getDropdownOptions} from '../../util/DropdownUtil';
import BaseControl from './BaseControl';

class SelectControl extends BaseControl {

    constructor(props) {
        super(props);

        this.state = {
            options: getDropdownOptions(props.options ? props.options : [], props.name, props.nameKey ),
            selected: props.selected ? props.selected : undefined,
            valueKey:  props.valueKey ? props.valueKey : '',
            nameKey: props.nameKey ? props.nameKey : '',
            name: props.name ? props.name: '',
            hasError: props.hasError,
            error: props.error ? props.error : '',
            placeholder: props.placeholder ? props.placeholder : 'Select...',
            isLoading: props.isLoading ? props.isLoading : false,
            isDisabled: props.isDisabled ? props.isDisabled : false,
            isSearchable: props.isSearchable,
            styles: props.styles ? props.styles : undefined
        }
    }

    getSelectedKey(selected, valueKey) {
        if (!selected || selected === -1) {
            return '';
        }

        if (valueKey && selected[valueKey] != null) {
            return String(selected[valueKey]);
        }

        if (typeof selected === 'object' && selected.value != null) {
            return String(selected.value);
        }

        return String(selected);
    }

    getOptionsSignature(options, valueKey, nameKey) {
        if (!options || options.length === 0) {
            return '';
        }

        return options.map(option => {
            if (!option) {
                return '';
            }

            const value = valueKey && option[valueKey] != null ? option[valueKey] : option.value;
            const name = nameKey && option[nameKey] != null ? option[nameKey] : option.name;
            return `${value}:${name}`;
        }).join('|');
    }

    componentWillReceiveProps(props) {
        const options = getDropdownOptions(props.options ? props.options : [], props.name, props.nameKey);
        const selected = props.selected ? props.selected : undefined;
        const valueKey = props.valueKey ? props.valueKey : '';
        const nameKey = props.nameKey ? props.nameKey : '';
        const name = props.name ? props.name : '';
        const hasError = props.hasError;
        const error = props.error ? props.error : '';
        const placeholder = props.placeholder ? props.placeholder : 'Select...';
        const isLoading = props.isLoading ? props.isLoading : false;
        const isDisabled = props.isDisabled ? props.isDisabled : false;
        const styles = props.styles ? props.styles : undefined;
        const isSearchable = props.isSearchable;

        const optionsChanged = this.getOptionsSignature(options, valueKey, nameKey) !==
            this.getOptionsSignature(this.state.options, this.state.valueKey, this.state.nameKey);
        const selectedChanged = this.getSelectedKey(selected, valueKey) !==
            this.getSelectedKey(this.state.selected, this.state.valueKey);

        if (!optionsChanged &&
            !selectedChanged &&
            valueKey === this.state.valueKey &&
            nameKey === this.state.nameKey &&
            name === this.state.name &&
            hasError === this.state.hasError &&
            error === this.state.error &&
            placeholder === this.state.placeholder &&
            isLoading === this.state.isLoading &&
            isDisabled === this.state.isDisabled &&
            styles === this.state.styles &&
            isSearchable === this.state.isSearchable) {
            return;
        }

        this.setState({
            options: options,
            selected: selected,
            valueKey: valueKey,
            nameKey: nameKey,
            name: name,
            hasError: hasError,
            error: error,
            placeholder: placeholder,
            isLoading: isLoading,
            isDisabled: isDisabled,
            styles: styles,
            isSearchable: isSearchable
        });
    }

    getValue() {

        if(!this.state.selected || this.state.selected == -1) {
            return null;
        }

        if(this.state.valueKey) {
            const result = this.state.options.find(option => option.value[this.state.valueKey] == this.state.selected[this.state.valueKey]);

            if(result) {
                return result;
            }
        }
        return this.state.options.find(option => option.value[this.state.valueKey] == this.state.selected)
    }

    render() {

        const hasError = this.props.hasError != null ? this.props.hasError : this.state.hasError;
        const error = this.props.error != null ? this.props.error : this.state.error;

        return (
            <div className={'select-control-container' + (hasError ? ' error' : '')}>
                {
                    this.props.label &&
                    <label>{ this.props.label }</label>
                }

                <Select
                    label={ this.props.label }
                    placeholder={ this.state.placeholder }
                    onChange={ (event) => this.onChange(event) }
                    options={ this.state.options }
                    value={this.getValue()}
                    isClearable={ this.props.isClearable }
                    isLoading={this.state.isLoading}
                    isDisabled={this.state.isDisabled}
                    styles={this.props.styles != null ? this.props.styles : this.state.styles}
                    menuPosition={'fixed'}
                    name={this.state.name}
                    id={this.state.name}
                    isOptionDisabled={(option) => option.disabled === true}
                    isSearchable={this.state.isSearchable}
                />

                {
                    hasError &&
                    <p className='error'>{ error }</p>
                }
            </div>
        )
    }
}

export default SelectControl;
